import * as React from 'react';
import styles from './Divider.module.less';
export const Divider = () => React.createElement("hr", { className: styles.divider });
